import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { selectFirestoreSession } from '@store/actionSlices/firestore'
import { selectProjectIdentity } from '@store/actionSlices/projectIdentity'
import { selectToken } from '@store/actionSlices/token'
import { RouteKey, Template } from '@store/constants'

import useTemplateHandler from '@components/template-handler/use-template-handler'

function useRouteUtils() {
  const history = useHistory()
  const location = useLocation()
  const projectIdentity = useSelector(selectProjectIdentity)
  const token = useSelector(selectToken)
  const session = useSelector(selectFirestoreSession)

  const disableLotViewRedirection = useRef(false)

  const selectedTemplate = useTemplateHandler({
    projectIdentity,
    token,
  })

  const hasDataLoaded = !!session?.connected && !!selectedTemplate

  const canRedirectToLotView =
    !disableLotViewRedirection.current &&
    selectedTemplate === Template.Default &&
    location.pathname !== `/${RouteKey.LOT_VIEW}` &&
    session?.activeRoute === RouteKey.STAGES &&
    !!session?.houseAndLand?.activeLotId &&
    !!session?.houseAndLand?.activeStageId

  useEffect(() => {
    if (!hasDataLoaded) {
      return
    }
    if (canRedirectToLotView) {
      history.replace(RouteKey.LOT_VIEW)
    }
    disableLotViewRedirection.current = true
  }, [hasDataLoaded, canRedirectToLotView])

  return {
    canRedirectToLotView,
  }
}

export default useRouteUtils
